import React from "react";
import { useStateWithUrlParams } from "../hooks/useStateWithUrlParams.js";
import { usePaginationParams } from "../pagination/usePaginationParams.js";

export function useFiltersAndPagination<Sorting = {}, Filters = {}>(
  defaultFilters: Filters,
  defaultSortings: Sorting[],
  defaultItemsPerPage: number = 25,
  pageUrlParam: string = "page",
  perPageUrlParam: string = "pageSize",
  filtersUrlParam: string = "filters",
  sortingsUrlParam: string = "sortings"
) {
  const {
    offset,
    limit,
    page,
    setPage,
    perPage,
    setPerPage,
    paginationModel,
    setPaginationModel,
  } = usePaginationParams({
    perPageDefaultAmount: defaultItemsPerPage,
    pageUrlParam,
    perPageUrlParam,
  });

  const toRemoveParams: string[] = [pageUrlParam];

  const [filters, setFilters] = useStateWithUrlParams<Filters>(
    filtersUrlParam,
    defaultFilters,
    toRemoveParams
  );
  const resetFilters = React.useCallback(() => {
    setFilters(defaultFilters);
  }, [defaultFilters, setFilters]);

  const [sorting, setSorting] = useStateWithUrlParams<Sorting[]>(
    sortingsUrlParam,
    defaultSortings,
    toRemoveParams
  );

  return {
    offset,
    limit,
    page,
    setPage,
    perPage,
    setPerPage,
    paginationModel,
    setPaginationModel,
    filters,
    setFilters,
    resetFilters,
    sorting,
    setSorting,
    toRemoveParams,
  };
}
